import React, { useState } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { BottomNextButton } from "../../../../components/common/BottomNextButton";
import { motion, PanInfo } from "framer-motion";
import promotion2 from "../../../../static/image/promotion/login/2.png";
import promotion4 from "../../../../static/image/promotion/login/4.png";
import promotion5 from "../../../../static/image/promotion/login/5.png";
import promotion6 from "../../../../static/image/promotion/login/6.png";
import promotion9 from "../../../../static/image/promotion/login/9.png";
import promotion10 from "../../../../static/image/promotion/login/10.png";

const carouselItems = [
  { title: "이론 배우기", image: promotion2 },
  { title: "패턴 발견하기", image: promotion4 },
  { title: "명상 훈련", image: promotion5 },
  { title: "생각 다루기", image: promotion6 },
  { title: "나 이해하기", image: promotion9 },
  { title: "가치 발견하기", image: promotion10 },
];

const ITEM_WIDTH = 226;
const ITEM_GAP = 12;
const MAX_VIEWPORT_WIDTH = ITEM_WIDTH * 1.8 + ITEM_GAP * 2;

export default function Introduction_2() {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    navigate(`/onboarding_new/introduction/3`, { replace: true });
  };

  const handleDragEnd = (_: any, info: PanInfo) => {
    const threshold = 50;
    const velocityThreshold = 500;

    if (
      (info.offset.x < -threshold || info.velocity.x < -velocityThreshold) &&
      currentIndex < carouselItems.length - 1
    ) {
      setCurrentIndex((prev) => prev + 1);
    } else if (
      (info.offset.x > threshold || info.velocity.x > velocityThreshold) &&
      currentIndex > 0
    ) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "70vh",
        overflow: "hidden",
      }}
    >
      <Stack
        sx={{
          height: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack spacing={2} sx={{ px: "20px" }}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            다양한 활동들이 준비되어 있습니다.
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            심리적 괴로움을 다스리며, 내가 원하는 방향으로 삶을 이끄는 방법을
            배웁니다.
          </CustomTypography>
        </Stack>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 0,
            marginTop: "26px",
            overflow: "hidden",
          }}
        >
          <motion.div
            drag="x"
            dragDirectionLock
            onDragEnd={handleDragEnd}
            dragMomentum={false}
            dragElastic={0.1}
            dragConstraints={{
              left: -(carouselItems.length - 1) * (ITEM_WIDTH + ITEM_GAP),
              right: 0,
            }}
            animate={{ x: -currentIndex * (ITEM_WIDTH + ITEM_GAP) }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            style={{
              display: "flex",
              height: "100%",
              cursor: "grab",
              userSelect: "none",
              WebkitUserSelect: "none",
            }}
          >
            <Box
              sx={{
                flex: `0 0 calc(50% - ${ITEM_WIDTH / 2}px)`,
                flexShrink: 0,
              }}
            />
            {carouselItems.map((item, index) => (
              <Box
                key={index}
                sx={{
                  width: `${ITEM_WIDTH}px`,
                  height: "100%",
                  marginRight: `${ITEM_GAP}px`,
                  flexShrink: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: index === currentIndex ? 1 : 0 }}
                  transition={{ duration: 0.4 }}
                  style={{ marginBottom: "12px" }}
                >
                  <CustomTypography
                    variant="Body"
                    sx={{
                      px: 0,
                      py: 0,
                      color: theme.vars.palette.Content.Medium,
                      fontWeight: 500,
                      textAlign: "center",
                    }}
                  >
                    {item.title}
                  </CustomTypography>
                </motion.div>
                <img
                  src={item.image}
                  alt={item.title}
                  draggable={false}
                  style={{
                    width: "226px",
                    height: "auto",
                    maxHeight: "calc(100% - 44px)",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            ))}
          </motion.div>
        </Box>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
